import { ImageSlidesSliceDefault } from "prismicio-types";
import { withConfigure } from "hyam-core/utils/withConfigure";
import { styles as moduleStyles, S01ImageSlidesDefaultStyles } from "./styles";
import { HyamPrismicImage, HyamPrismicRichText } from "hyam-prismic/components/elements";
import cn from "classnames";
import { useWindowSize } from "usehooks-ts";

export type S01ImageSlidesDefaultProps = {
  slice: ImageSlidesSliceDefault;
  index: number;
  styles?: Partial<S01ImageSlidesDefaultStyles>;
  stylesReplace?: Partial<S01ImageSlidesDefaultStyles>;
};

const _S01ImageSlidesDefault = (props: S01ImageSlidesDefaultProps) => {
  const { width } = useWindowSize();

  let breakpoint: "sm" | "md" | "xl" | "2xl" = "sm";
  if (width > 767) {
    breakpoint = width > 1279 ? (width > 1535 ? "2xl" : "xl") : "md";
  }

  const { slice } = props;
  const items = slice?.items;
  const styles = props.styles as S01ImageSlidesDefaultStyles;

  return (
    <section className={styles.container}>
      <div className="fixed z-10 bg-[#EEEAE5] w-screen h-screen inset-0"></div>
      <div className="w-full h-fit z-20 relative flex flex-col [&>.slide+.slide]:pb-10 md:[&>.slide+.slide]:pb-20">
        {items.map((slide, i) => {
          const isAboveFold = i < 2;
          const firstOrLast = i == 0 || i == items.length - 1;
          const positionY =
            paddingY[i] && paddingY[i][breakpoint] !== undefined
              ? paddingY[i][breakpoint]
              : 0;
          return (
            <div
              className={cn("w-full h-fit slide bg-[#EEEAE5] relative last:!pb-0", {
                "!bg-black": firstOrLast,
              })}
              key={i}
            >
              {firstOrLast && (
                <div
                  className={cn(
                    "bg-black h-full absolute w-screen ml-[calc(50%-50vw)] ",
                    {
                      "after:content-[''] after:w-full after:h-full after:bg-black after:block after:-translate-y-full":
                        i == 0,
                    },
                  )}
                ></div>
              )}
              {i == items.length - 1 && (
                <a
                  href="mailto:hello@open-space.berlin"
                  className="w-1/3 h-1/2 bg-transparent absolute top-0 z-10 translate-y-1/2"
                ></a>
              )}
              <HyamPrismicImage
                sizesByBreakpoint={{ sm: 1, lg: 1, xl: 1 }}
                field={slide.image}
                styles={{ container: "[&_img]:!h-auto" }}
                priority={isAboveFold ? true : undefined}
              />
              <div style={{ translate: `0 ${positionY}px` }}>
                <HyamPrismicRichText
                  styles={{
                    paragraph: styles.text,
                  }}
                  field={slide?.text}
                />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const paddingY = [
  {
    sm: 0,
    md: 0,
    xl: 0,
    "2xl": 0,
  },
  {
    sm: 0,
    md: 0,
    xl: 0,
    "2xl": 0,
  },
  {
    sm: 0,
    md: 0,
    xl: 0,
    "2xl": 0,
  },
  {
    sm: 0,
    md: 0,
    xl: 0,
    "2xl": 0,
  },
  {
    sm: 0,
    md: 0,
    xl: 0,
    "2xl": 0,
  },
  // Hard facts
  {
    sm: 20,
    md: 60,
    xl: 40,
    "2xl": 0,
  },
  {
    sm: 0,
    md: 0,
    xl: 0,
    "2xl": 0,
  },
  //Apero
  {
    sm: 50,
    md: 70,
    xl: 95,
    "2xl": 20,
  },
  //Kaltwaser
  {
    sm: 50,
    md: 70,
    xl: 70,
    "2xl": 0,
  },
  //Nusa
  {
    sm: 65,
    md: 110,
    xl: 140,
    "2xl": 130,
  },
  //CDI
  {
    sm: 15,
    md: 20,
    xl: -10,
    "2xl": -60,
  },
  //Ambient
  {
    sm: 55,
    md: 90,
    xl: 140,
    "2xl": 110,
  },
  //Classic
  {
    sm: 50,
    md: 80,
    xl: 100,
    "2xl": 50,
  },
  //Uplifted
  {
    sm: 10,
    md: 20,
    xl: -20,
    "2xl": -60,
  },
  //Matko
  {
    sm: 10,
    md: 20,
    xl: -20,
    "2xl": -60,
  },
];

export const S01ImageSlidesDefault = withConfigure<
  S01ImageSlidesDefaultProps,
  S01ImageSlidesDefaultStyles
>({
  componentName: "S01ImageSlidesDefault",
  Component: _S01ImageSlidesDefault,
  moduleStyles,
});
